<script>
import Barlist from '../components/bar-list'
import PedidoFiltro from '../components/pedido-filtro'
import BarGrid from '../components/bar-grid.vue'
import ConsultaVarejoPendcli from '../consultas/consulta-varejo-pendcli.vue'

export default {
  components: {
    BarGrid,
    Barlist,
    PedidoFiltro,
    ConsultaVarejoPendcli
  },

  props: {
    codvabertura: null,
  },

  data() {
    return {

      show: true,
    }
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },

  },
  computed: {

  },
  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })
  },
  beforeDestroy() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip('dispose').removeAttr('data-toggle')
    })
  }

}
</script>
<template>
  <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document"
      style="max-width: 90%; width: 90% !important;overflow-y: initial !important;">
      <div class="modal-content">
        <div class="modal-body pt-3" style="height: 80vh!important; max-height: 100%; overflow-y: auto;">
          <div class="lbl mb-2" style="font-size: 20px">
            <strong>Controle Pendencias Cliente</strong>
          </div>
          <button @click="closeModal" class="close">
            <span>&times;</span>
          </button>
          <div v-if="show">
            <ConsultaVarejoPendcli :codvabertura="this.codvabertura" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

</style>









// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-pendcli.vue